



























































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';
@Component({
	components: {},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	private showPicker: any = false; // 展示隐藏
	private popupValue: any = [];
	private changeStatus() {
		this.showPicker = false;
		this.popupValue = [];
		this.form.filterValue = '';
	}
	// 确定
	private comfirm() {
		if (this.item && this.item.fieldType === 'checkbox') {
			this.form.filterValue = this.popupValue.join(',');
		} else {
			this.form.filterValue = String(this.popupValue);
		}
		this.showPicker = false;
		this.$emit('change');
	}
	// 清空选项
	private clear() {
		this.popupValue = [];
	}
	// 打开抽屉
	private show() {
		this.showPicker = true;
	}
	private get currentCheckbox() {
		return this.item.options.filter((option) => {
			return this.popupValue.includes(option.key);
		});
	}
	private get currentRadio() {
		return this.item.options.filter((option) => {
			return [this.popupValue].includes(option.key);
		});
	}
	@Watch('form.businessId')
	private onChildChanged() {
		if (this.item && this.item.fieldType === 'checkbox') {
			this.popupValue = [];
		} else {
			this.popupValue = '';
		}
	}
	@Watch('$route.params.viewId')
	private ChildChanged() {
		if (this.item && this.item.fieldType === 'checkbox') {
			this.popupValue = [];
		} else {
			this.popupValue = '';
		}
	}
}
